import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { string } from 'prop-types';
import ApiRoutes from '../store/ApiRoutes';
import { func } from 'prop-types';
import { getBrokerDistribution } from '../services/brokerDataService';

const UpgradePopupOnBrokerLoginScreen = ({ startScreen, close }) => {
  const { t } = useTranslation();
  const [popupContentState, setPopupContentState] = useState(startScreen);
  const [sendEmailStatus, setSendEmailStatus] = useState('initial');
  const api = new ApiRoutes();

  useEffect(() => {
    switch (sendEmailStatus) {
      case `initial`:
        break;
      case `pending`:
        break;
      case `success`:
        setPopupContentState('close');
        break;
      case `error`:
        break;
      default:
        return;
    }
  }, [sendEmailStatus]);

  async function wantsToUpgrade() {
    const { email } = getBrokerDistribution();
    const payload = {
      data: {
        trial_user: email,
      },
    };
    try {
      await api.postWantsAnUpgrade(payload);
      await setSendEmailStatus('success');
    } catch (error) {
      setSendEmailStatus('error');
    }
  }

  switch (popupContentState) {
    case 'upgrade_bronze':
      return (
        <ErrorPopup
          onClick={() => setPopupContentState('close')}
          data-test-id={'popup_broker_bronze_forbidden'}
        >
          <PopupContainer onClick={e => e.stopPropagation()}>
            <Close
              onClick={() => setPopupContentState('close')}
              data-test-id={'close_popup_broker_bronze_forbidden'}
            >
              x
            </Close>
            <Title>{t('Feature not available for bronze')}</Title>
            <Text
              dangerouslySetInnerHTML={{
                __html: t(
                  'This feature is not available within your current Bronze subscription Do you wish to request an upgrade to your subscription?',
                ),
              }}
            ></Text>
            <Button
              data-test-id={'upgrade_popup_broker_bronze_forbidden'}
              onClick={() => {
                setSendEmailStatus('pending');
                wantsToUpgrade();
              }}
            >
              {t('I want to upgrade')}
            </Button>
          </PopupContainer>
        </ErrorPopup>
      );
    case 'close':
      close(false);
      setPopupContentState(startScreen);
      setSendEmailStatus('initial');
      return null;
    default:
      return;
  }
};

const Close = styled.span`
  font-size: 2.5rem;
  position: absolute;
  top: 1.6rem;
  left: 2.5rem;
  cursor: pointer;
`;

const PopupContainer = styled.div`
  position: relative;
  max-width: 100rem;
  background-color: white;
  border-radius: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: 0.3s fade;
  padding: 4rem;

  @keyframes fade {
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  }
`;

const Button = styled.button`
  background-color: ${({ theme, secondary }) =>
    secondary ? 'none' : theme.brand.primary};
  border-radius: 0.5rem;
  display: flex;
  font-size: 2rem;
  justify-content: center;
  align-items: center;
  color: ${props => (props.secondary ? 'gray' : 'white')};
  border: 0;
  font-weight: bold;
  margin: 1rem;
  text-decoration: none;
  align-self: center;
  margin-bottom: 1rem;
  margin-right: 2rem;
  z-index: 100;
  cursor: pointer;
  transition: all 0.2s ease 0s;
  margin-top: 4rem;
  padding: 1rem 3rem;

  &:active {
    outline: none;
    transform: scale(0.98);
  }

  &:focus {
    border: 0 0 0;
    outline: none;
  }

  &:hover {
    background-color: ${({ theme, secondary }) =>
      secondary ? 'none' : theme.brand.lighter};
    color: ${props => (props.secondary ? 'black' : 'white')};
  }

  &:disabled {
    cursor: default;
    background-color: ${({ theme }) => theme.brand.lighter};
  }

  @media screen and (max-width: 1025px) {
    transform: scale(0.9);
    margin-bottom: 1rem;

    &:active {
      transform: scale(0.88);
    }
  }
`;

const ErrorPopup = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: 900;
`;
const Text = styled.p`
  font-size: 1.8rem;
  font-weight: 400;
  width: 80%;
  text-align: center;
  margin-top: 3rem;
`;

UpgradePopupOnBrokerLoginScreen.propTypes = {
  startScreen: string.isRequired,
  close: func.isRequired,
};

export default UpgradePopupOnBrokerLoginScreen;
